import { inject, Injectable } from '@angular/core';
import { API_URLS, WebServiceProvider } from '@pinnakl/core/web-services';
import { SecurityType } from '@pinnakl/securities/domain';

@Injectable({ providedIn: 'root' })
export class SecurityTypesApiService {
  private readonly wsp = inject(WebServiceProvider);
  private readonly apiUrls = inject(API_URLS);

  getSecurityTypes(): Promise<SecurityType[]> {
    return this.wsp.get<SecurityType[]>({
      endpoint: this.apiUrls.securityTypesV3,
      queryParams: {
        options: JSON.stringify({
          fields: ['id', 'assetTypeId', 'secType', 'secTypeDescription', 'isDefaultType'],
        }),
      },
    });
  }
}
